import React from 'react';

const emojis = [
  '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
  '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙',
  '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔',
  '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥',
  '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮',
  '❤️', '💔', '💕', '💖', '💗', '💙', '💚', '💛', '🧡', '💜',
  '👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉',
  '🎉', '🎊', '🎁', '🎈', '🎂', '🎄', '🎃', '🎆', '🎇', '✨',
];

const EmojiPicker = ({ onSelect }) => {
  return (
    <div className="emoji-content-wrap">
      <div className="emoji-content">
        {emojis.map((emoji, index) => (
          <span
            key={index}
            className="emoji-item"
            onClick={() => onSelect(emoji)}
            style={{ cursor: 'pointer', fontSize: '24px', margin: '5px' }}
          >
            {emoji}
          </span>
        ))}
      </div>
    </div>
  );
};

export default EmojiPicker;

